module.exports = __webpack_public_path__ + "static/go_zen_chu-3fafcaa5f344b7eb6588e2554c6b32c2.png";